import React, {Component} from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { login, signup } from '../../../store/actions/Authentication';

function mapStateToProps(state) {
  return {
    isLoginPending: state.authentication.isLoginPending,
    isLoginSuccess: state.authentication.isLoginSuccess,
    loginError: state.authentication.loginError,
    validateUsernameError: state.authentication.validateUsernameError,
    validateUsernameErrorMessage: state.authentication.validateUsernameErrorMessage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    login: (email, password) => {
      dispatch(login(email, password));
    },
    signup: (email, password, username) => {
      dispatch(signup(email, password, username));
    }
  };
}

class LoginForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      signup: true,
      usernameError: false,
      usernameErrorMessage: null,
      emailError: false,
      emailErrorMessage: null,
      passwordError: false,
      passwordErrorMessage: null,
      hasAcceptedTerms: false,
    };
    this.toggleSignup = this.toggleSignup.bind(this);
    this.login = this.login.bind(this);
    this.signup = this.signup.bind(this);
    this.validateUsername = this.validateUsername.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.validatePassword = this.validatePassword.bind(this);
    this.handleCheckAcceptTerms = this.handleCheckAcceptTerms.bind(this);
  } 

  toggleSignup() {
    this.setState({ signup: !this.state.signup })
  } 

  signup(e) {
    e.preventDefault();
    let { username, email, password, passwordConfirm } = this.state;

    // Validate Forms
    if (!this.validateUsername(username)) { return }
    if (!this.validateEmail(email)) { return }
    if (!this.validatePassword(password, passwordConfirm)) { return }

    this.props.signup(email, password, username);
    this.setState({
      username: '',
      email: '',
      password: '',
      passwordConfirm: ''
    });
  }

  login(e) {
    e.preventDefault();
    let { email, password } = this.state;
    this.props.login(email, password);
    this.setState({
      email: '',
      password: ''
    });
  }

  validateUsername(username) {
    const usernameBlacklist = ['admin', 'root', 'abuse', 'webmaster', 'spam', 'help']

    if (!username) {
      this.setState({
        usernameError: true,
        usernameErrorMessage: 'Please enter a username'
      })
      return false; 
    }

    if (usernameBlacklist.indexOf(username) !== -1)  {
      this.setState({
        usernameError: true,
        usernameErrorMessage: 'That username is not allowed'
      })
      return false; 
    }

    if (username.length < 4 || username.length > 15) {
      this.setState({
        usernameError: true,
        usernameErrorMessage: 'Please select a username between 4 and 15 characters long'
      })
      return false;  
    }

    this.setState({
      usernameError: false,
      usernameErrorMessage: null
    })
    return true;
  }

  validateEmail(email) {
    if (!email) {
      this.setState({
        emailError: true,
        emailErrorMessage: 'Please enter an email'
      })
      return false; 
    }
    this.setState({
      emailError: false,
      emailErrorMessage: null
    })
    return true;
  }

  validatePassword(password, passwordConfirm) {

    if (!password || !passwordConfirm) {
      this.setState({ 
        passwordError: true,
        passwordErrorMessage: 'Please enter a password'
      })
      return false;
    } 
    
    if (password !== passwordConfirm) {
      this.setState({ 
        passwordError: true,
        passwordErrorMessage: 'Your passwords don\'t match'
      })
      return false;
    } 

    if (password.length < 8 || password.length > 32) {
      this.setState({
        passwordError: true,
        passwordErrorMessage: 'Passwords must be between 8 and 32 characters long'
      })
      return false;  
    }

    this.setState({ 
      passwordError: false,
      passwordErrorMessage: null
    })
    return true;
  }

  handleCheckAcceptTerms() {
    this.setState({hasAcceptedTerms: !this.state.hasAcceptedTerms});
  }

  render() {
    const { signup, 
            alertStatus, 
            username, 
            email, 
            password, 
            passwordConfirm, 
            usernameError,
            usernameErrorMessage,
            emailError,
            emailErrorMessage,
            passwordError,
            passwordErrorMessage,
            hasAcceptedTerms } = this.state;

    const { isLoginPending, 
            isLoginSuccess, 
            loginError,
            validateUsernameError,
            validateUsernameErrorMessage } = this.props;

    let signupForm = (
      <form name="signupForm" onSubmit={this.signup}>
        <h1>Hello!</h1>
        <h3>Create your account</h3>
        <div className="formRow">
          <label>Your Username</label>
          <input 
            type="text" 
            name="username" 
            placeholder="Username" 
            value={username} 
            onChange={e => this.setState({username: e.target.value.replace(/\s/g, '')})}  
          />
        </div>
        <div className="formRow">
          <label>Your Email</label>
          <input 
            type="email" 
            name="email" 
            placeholder="Email" 
            value={email} 
            onChange={e => this.setState({email: e.target.value})} 
          />
        </div>
        <div className="formRow">
          <label>Select a Password</label>
          <input 
            type="password" 
            name="password" 
            placeholder="Password" 
            value={password} 
            onChange={e => this.setState({password: e.target.value})} 
          />
        </div>
        <div className="formRow">
          <label>Confirm your Password</label>
          <input 
            type="password" 
            name="passwordConfirm" 
            placeholder="Confirm password" 
            value={passwordConfirm} 
            onChange={e => this.setState({passwordConfirm: e.target.value})} 
          />
        </div>
        <div className="checkbox__row">
          <div className="checkbox__item">
            <input
              type="checkbox" 
              id="checkbox_terms" 
              alt="Filter Clips that don't have reports"
              onChange={this.handleCheckAcceptTerms}
              defaultChecked={this.state.hasAcceptedTerms}
            />
            <label htmlFor="checkbox_terms" className="legal-text">
              By signing up I agree to Gabwalla's <Link to="terms">Terms & Conditions</Link> and <Link to="privacy">Privacy Policy</Link>
            </label>
          </div>
        </div>

        <input 
          className="btn btn--primary btn--100" 
          type="submit" 
          value="Sign Up" 
          disabled={ !hasAcceptedTerms }
        />
        <a className="LoginForm__toggle" onClick={this.toggleSignup}>I already have an account. Log In.</a>
      </form>
    )

    let loginForm = (
      <form name="loginForm" onSubmit={this.login}>
        <h1>Welcome back!</h1>
        <h3>Log in to your account</h3>
        <div className="formRow">
          <label>Your Email</label>
          <input 
            type="email" 
            name="email" 
            placeholder="Email" 
            value={email} 
            onChange={e => this.setState({email: e.target.value})} 
          />
        </div>
        <div className="formRow">
          <label>Your Password</label>
          <input 
            type="password" 
            name="password" 
            placeholder="Password" 
            value={password} 
            onChange={e => this.setState({password: e.target.value})} 
          />
        </div>
        <p>
          <input className="btn btn--primary btn--100" type="submit" value="Login" />
        </p>
        <p className="legal-text center">
          By logging in I agree to Gabwalla's <Link to="terms">Terms & Conditions</Link> and <Link to="privacy">Privacy Policy</Link>
        </p>
        <p>
          <a className="LoginForm__toggle" onClick={this.toggleSignup}>I don't have an account. Sign up.</a>
        </p>
      </form>
    )

    return (
      <div className="LoginForm card">
        { signup ? signupForm : loginForm }
        <p className="LoginForm__error">
          { isLoginPending && <div>Please wait...</div>}
          { isLoginSuccess && <div>Success.</div>}
          { loginError && <div>{loginError.message}</div> }
          { usernameError && <div>{usernameErrorMessage}</div> }
          { emailError && <div>{emailErrorMessage}</div> }
          { passwordError && <div>{passwordErrorMessage}</div> }
          { validateUsernameError && <div>{validateUsernameErrorMessage}</div> }
        </p>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);


// WEBPACK FOOTER //
// ./src/components/Forms/LoginForm/LoginForm.js